const DRAFT_KEY_PREFIX = 'order_logistics_draft_';

// In-memory map for fast synchronous access in SPA
const memoryDrafts = new Map();

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
  // If page was refreshed/reloaded, clear any existing drafts
  try {
    const navEntries = performance.getEntriesByType?.('navigation');
    const isReload = navEntries?.[0]?.type === 'reload';
    if (isReload) {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(DRAFT_KEY_PREFIX)) {
          sessionStorage.removeItem(key);
        }
      });
    } else {
      // Restore memoryDrafts from sessionStorage across tab/sidebar navigation
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(DRAFT_KEY_PREFIX)) {
          const orderId = key.replace(DRAFT_KEY_PREFIX, '');
          try {
            const parsed = JSON.parse(sessionStorage.getItem(key));
            if (parsed) memoryDrafts.set(orderId, parsed);
          } catch (e) {
            // ignore
          }
        }
      });
    }
  } catch (e) {
    // ignore
  }

  // Clear drafts on browser page refresh / unload
  window.addEventListener('beforeunload', () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(DRAFT_KEY_PREFIX)) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      // ignore
    }
  });
}

export const setOrderDraft = (orderId, data) => {
  if (!orderId) return;
  const idStr = String(orderId);
  memoryDrafts.set(idStr, data);
  if (isBrowser) {
    try {
      sessionStorage.setItem(`${DRAFT_KEY_PREFIX}${idStr}`, JSON.stringify(data));
    } catch (e) {
      // ignore
    }
  }
};

export const getOrderDraft = (orderId) => {
  if (!orderId) return null;
  const idStr = String(orderId);
  if (memoryDrafts.has(idStr)) {
    return memoryDrafts.get(idStr);
  }
  if (isBrowser) {
    try {
      const raw = sessionStorage.getItem(`${DRAFT_KEY_PREFIX}${idStr}`);
      if (raw) {
        const parsed = JSON.parse(raw);
        memoryDrafts.set(idStr, parsed);
        return parsed;
      }
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const clearOrderDraft = (orderId) => {
  if (!orderId) return;
  const idStr = String(orderId);
  memoryDrafts.delete(idStr);
  if (isBrowser) {
    try {
      sessionStorage.removeItem(`${DRAFT_KEY_PREFIX}${idStr}`);
    } catch (e) {
      // ignore
    }
  }
};
